export default {
  isLoading: false,
  error: false,
  errorMessage: null,
  loyaltyItems: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  loyaltyItem: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
  loyaltyItemCategory: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
};
